import { create } from "zustand";

import { JobsResponse } from "@/types";

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type JobsStore = {
  isLoading: boolean;
  jobs: JobsResponse[];
  setIsLoading: (isLoading: boolean) => void;
  setJobs: (jobs: JobsResponse[]) => void;
};

// TODO: Probably want a better mechanism for handling loading.
export const jobsStore = create<JobsStore>((set) => ({
  isLoading: true,
  jobs: [],
  setIsLoading(isLoading) {
    set({ isLoading });
  },
  setJobs(jobs) {
    set({ jobs });
  },
}));
